module.exports = __webpack_public_path__ + "static/media/5.ff191f9f.svg";